/**
 * Keeps a day-timeline column's labels from printing on top of each other. Two feeds five
 * minutes apart sit ~2px apart on the rail, so each label is nudged down just enough to
 * clear the one above it (then back up from the bottom if that ran off the end). Order is
 * preserved; a label only moves when it has to, so a lone mark still sits on its time.
 *
 * `ys` are the ideal pixel positions (any order); the result is index-aligned with them.
 */
export function spreadLabels(ys: readonly number[], minGap: number, maxY: number): number[] {
  const order = ys.map((y, index) => ({ y, index })).sort((a, b) => a.y - b.y || a.index - b.index);
  const placed = order.map((entry) => entry.y);
  for (let i = 1; i < placed.length; i += 1) {
    placed[i] = Math.max(placed[i] as number, (placed[i - 1] as number) + minGap);
  }
  for (let i = placed.length - 1; i >= 0; i -= 1) {
    const ceiling = i === placed.length - 1 ? maxY : (placed[i + 1] as number) - minGap;
    placed[i] = Math.max(0, Math.min(placed[i] as number, ceiling));
  }
  const out = new Array<number>(ys.length);
  order.forEach((entry, sortedIndex) => {
    out[entry.index] = placed[sortedIndex] as number;
  });
  return out;
}
